import { BreadCrumb } from 'primereact/breadcrumb';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
const BookingpartnervwListPage = (props) => {
		const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: "Search",
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, apiUrl, sortBy, sortOrder, apiRequestError, getPageBreadCrumbs, onSort, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function PickupdateTemplate(data){
		if(data){
			return (
				<>{utils.humanDatetime( data.pickupdate )}</>
			);
		}
	}
	function DeliverydateTemplate(data){
		if(data){
			return (
				<>{utils.humanDatetime( data.deliverydate )}</>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">Loading...</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					No record found
				</div>
			);
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-bookingpartnervw`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel="" tooltip="Export" buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">Records <b>{ recordsPosition } of { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="BookingpartnervwListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title="Booking Partner"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-12 md:col-3 " >
                    <span className="p-input-icon-left w-full">
                    <i className="pi pi-search" />
                    <InputText placeholder="Search" className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                    </span>
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container-fluid">
            <div className="grid ">
                <div className="col comp-grid" >
                    <FilterTags filterController={filterController} />
                    <div >
                        <PageBreadcrumbs />
                        <div className="page-records">
                            <DataTable 
                                lazy={true} 
                                loading={loading} 
                                value={records} 
                                dataKey="id" 
                                sortField={sortBy} 
                                sortOrder={sortOrder} 
                                onSort={onSort}
                                className=" p-datatable-sm" 
                                stripedRows={true}
                                showGridlines={false} 
                                rowHover={true} 
                                responsiveLayout="stack" 
                                emptyMessage={<EmptyRecordMessage />} 
                                >
                                {/*PageComponentStart*/}
                                <Column  field="id" header="Id"  sortable={true} ></Column>
                                <Column  field="bookingreference" header="Bookingreference"  sortable={true} ></Column>
                                <Column  field="userid" header="Userid"  sortable={true} ></Column>
                                <Column  field="serviceid" header="Serviceid"  sortable={true} ></Column>
                                <Column  field="partnerid" header="Partnerid"  sortable={true} ></Column>
                                <Column  field="status" header="Status"  sortable={true} ></Column>
                                <Column  field="pickupdate" header="Pickupdate" body={PickupdateTemplate} sortable={true} ></Column>
                                <Column  field="deliverydate" header="Deliverydate" body={DeliverydateTemplate} sortable={true} ></Column>
                                <Column  field="pickupaddress" header="Pickupaddress"   ></Column>
                                <Column  field="deliveryaddress" header="Deliveryaddress"   ></Column>
                                <Column  field="totalweight" header="Totalweight"   ></Column>
                                <Column  field="totalitems" header="Totalitems"   ></Column>
                                <Column  field="baseamount" header="Baseamount"   ></Column>
                                <Column  field="weightcharge" header="Weightcharge"   ></Column>
                                <Column  field="extracharges" header="Extracharges"   ></Column>
                                <Column  field="discountamount" header="Discountamount"   ></Column>
                                <Column  field="taxrate" header="Taxrate"   ></Column>
                                <Column  field="taxamount" header="Taxamount"   ></Column>
                                <Column  field="totalamount" header="Totalamount"   ></Column>
                                <Column  field="specialinstructions" header="Specialinstructions"   ></Column>
                                <Column  field="preferredcontactmethod" header="Preferredcontactmethod"   ></Column>
                                <Column  field="deliveryinstructions" header="Deliveryinstructions"   ></Column>
                                <Column  field="paymentstatus" header="Paymentstatus"   ></Column>
                                <Column  field="paymentmethod" header="Paymentmethod"   ></Column>
                                <Column  field="transactionid" header="Transactionid"   ></Column>
                                <Column  field="paymentdate" header="Paymentdate"   ></Column>
                                <Column  field="assignedstaffid" header="Assignedstaffid"   ></Column>
                                <Column  field="assigneddriverid" header="Assigneddriverid"   ></Column>
                                <Column  field="createdat" header="Createdat"   ></Column>
                                <Column  field="updatedat" header="Updatedat"   ></Column>
                                <Column  field="confirmedat" header="Confirmedat"   ></Column>
                                <Column  field="pickedupat" header="Pickedupat"   ></Column>
                                <Column  field="pickupconfirmedby" header="Pickupconfirmedby"   ></Column>
                                <Column  field="processingstartedat" header="Processingstartedat"   ></Column>
                                <Column  field="readyfordeliveryat" header="Readyfordeliveryat"   ></Column>
                                <Column  field="outfordeliveryat" header="Outfordeliveryat"   ></Column>
                                <Column  field="deliveredat" header="Deliveredat"   ></Column>
                                <Column  field="deliveryconfirmedby" header="Deliveryconfirmedby"   ></Column>
                                <Column  field="completedat" header="Completedat"   ></Column>
                                <Column  field="cancelledat" header="Cancelledat"   ></Column>
                                <Column  field="cancelledreason" header="Cancelledreason"   ></Column>
                                <Column  field="cancelledby" header="Cancelledby"   ></Column>
                                <Column  field="customerrating" header="Customerrating"   ></Column>
                                <Column  field="customerreview" header="Customerreview"   ></Column>
                                <Column  field="reviewdate" header="Reviewdate"   ></Column>
                                <Column  field="isurgent" header="Isurgent"   ></Column>
                                <Column  field="prioritylevel" header="Prioritylevel"   ></Column>
                                <Column  field="isrepeatcustomer" header="Isrepeatcustomer"   ></Column>
                                <Column  field="source" header="Source"   ></Column>
                                <Column  field="createdby" header="Createdby"   ></Column>
                                <Column  field="modifiedby" header="Modifiedby"   ></Column>
                                <Column  field="date_created" header="Date Created"   ></Column>
                                <Column  field="date_updated" header="Date Updated"   ></Column>
                                <Column  field="puserid" header="Puserid"   ></Column>
                                <Column  field="quantity" header="Quantity"   ></Column>
                                {/*PageComponentEnd*/}
                            </DataTable>
                        </div>
                        <PageFooter />
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
	);
}
BookingpartnervwListPage.defaultProps = {
	primaryKey: '',
	pageName: 'bookingpartnervw',
	apiPath: 'bookingpartnervw/index',
	routeName: 'bookingpartnervwlist',
	msgBeforeDelete: "Are you sure you want to delete this record?",
	msgTitle: "Delete record",
	msgAfterDelete: "Record deleted successfully",
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: false,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default BookingpartnervwListPage;
